import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  IDefectList,
  TDepartmentWiseOperationListAndGenericIssueMap,
  THandleIssueOperationSelectionList,
  TIssueCategory,
  TIssueType,
  TOperationAndSelectedGenericMappedIssueList,
  TOperationDTOWithMappedIssuesDTO,
  TUpdateFilteredListsV3,
} from '@monorepo/types';
import { InputAppAPIHelperUtil } from '@monorepo/utils';
import { FilterMasterdataListComponent } from '../filter-masterdata-list/filter-masterdata-list.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-issue-selection-v3',
  templateUrl: './issue-selection-v3.component.html',
  styleUrls: ['./issue-selection-v3.component.scss'],
})
export class IssueSelectionV3Component implements OnInit {
  @Input()
  get operationAndSelectedIssueList() {
    return this.#operationAndSelectedIssueList;
  }
  set operationAndSelectedIssueList(operationList: TOperationAndSelectedGenericMappedIssueList[]) {
    this.#operationAndSelectedIssueList = operationList;
    this.init();
  }
  @Input() departmentWiseOperationListAndGenericIssueMap!: TDepartmentWiseOperationListAndGenericIssueMap;
  @Output() back = new EventEmitter<TOperationAndSelectedGenericMappedIssueList[]>();
  @Output() next = new EventEmitter<TOperationAndSelectedGenericMappedIssueList[]>();
  @Output() cancel = new EventEmitter<'CANCEL'>();
  @Output() clearAll = new EventEmitter<'CLEAR_ALL'>();
  @Output() viewAll = new EventEmitter<TUpdateFilteredListsV3>();

  #operationAndSelectedIssueList!: TOperationAndSelectedGenericMappedIssueList[];
  backArrow = '/assets/md-point/header-back-arrow.svg';
  activeIndex: number = 0;
  selectedCategory: TIssueCategory | undefined;
  categoriesToShow = new Set<TIssueCategory>();
  filteredAllGenericIssue: IDefectList[] = [];
  filteredAllMappedIssues: IDefectList[] = [];
  filteredGenericIssue: IDefectList[] = [];
  filteredMappedIssues: IDefectList[] = [];
  currentOperationSelected!: TOperationDTOWithMappedIssuesDTO;
  showDepartmentNames: boolean = false;

  constructor(
    private inputAppAPIHelperUtil: InputAppAPIHelperUtil,
    private modalCtrl: ModalController,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    console.log('[operationAndSelectedIssueList]', this.operationAndSelectedIssueList);
    this.showDepartmentNames = Object.keys(this.departmentWiseOperationListAndGenericIssueMap).length > 1;
    this.init();
  }

  init() {
    this.filterCategories();
    this.updateFilteredIssues();
  }

  filterCategories() {
    this.setCurrentSelectedOperationBasedOnActiveIndex();
    const currentOperationDept = this.operationAndSelectedIssueList[this.activeIndex].operation.department;
    if (currentOperationDept) {
      this.departmentWiseOperationListAndGenericIssueMap[currentOperationDept].genericIssues.list.forEach((issue) =>
        this.categoriesToShow.add(issue.category),
      );
    }
  }

  updateFilteredIssues() {
    this.filterGeneralIssuesWithCategory();
    this.filterMappedIssues();
  }

  updateSelectedCategoryAndFilter(category: TIssueCategory | undefined) {
    this.selectedCategory = category;
    this.filterGeneralIssuesWithCategory();
  }

  filterMappedIssues() {
    const selectedOperationDepartment = this.operationAndSelectedIssueList[this.activeIndex].operation.department;
    if (selectedOperationDepartment) {
      const operationData = this.departmentWiseOperationListAndGenericIssueMap[
        selectedOperationDepartment
      ].operationsList.find(
        (operation) => operation.id === this.operationAndSelectedIssueList[this.activeIndex].operation.id,
      );
      if (operationData) {
        this.filteredAllMappedIssues = operationData.issues.map((issueData) => {
          return {
            category_id: '',
            group_id: [],
            group_name: issueData.issueName,
            id: issueData.issueId,
            name: issueData.issueName,
            category: undefined,
          };
        });

        if (operationData.filteredIssuesList) {
          this.filteredMappedIssues =
            operationData.filteredIssuesList?.length === 0
              ? this.filteredAllMappedIssues
              : this.filteredAllMappedIssues.filter((issue) => {
                  if (operationData.filteredIssuesList?.includes(issue.name)) {
                    return true;
                  }
                  return false;
                });
        } else {
          this.filteredMappedIssues = this.filteredAllMappedIssues;
        }
      }
    }
  }

  filterGeneralIssuesWithCategory() {
    const selectedOperationDepartment = this.operationAndSelectedIssueList[this.activeIndex].operation.department;
    if (selectedOperationDepartment) {
      this.filteredAllGenericIssue = this.departmentWiseOperationListAndGenericIssueMap[
        selectedOperationDepartment
      ].genericIssues.list
        .filter((issue) => {
          return this.selectedCategory ? issue.category === this.selectedCategory : true;
        })
        .map((issueData) => {
          return {
            category_id: '',
            group_id: [],
            group_name: issueData.issueName,
            id: issueData.issueId,
            name: issueData.issueName,
            category: issueData.category,
          };
        });

      if (
        this.departmentWiseOperationListAndGenericIssueMap[selectedOperationDepartment].genericIssues.filteredDefectList
      ) {
        this.filteredGenericIssue =
          this.departmentWiseOperationListAndGenericIssueMap[selectedOperationDepartment].genericIssues
            .filteredDefectList?.length === 0
            ? this.filteredAllGenericIssue
            : this.filteredAllGenericIssue.filter((issue) => {
                if (
                  this.departmentWiseOperationListAndGenericIssueMap[
                    selectedOperationDepartment
                  ].genericIssues.filteredDefectList?.includes(issue.name)
                ) {
                  return true;
                }
                return false;
              });
      } else {
        this.filteredGenericIssue = this.filteredAllGenericIssue;
      }

      console.log('[AFTER]', this.filteredGenericIssue);
    }
  }

  async onViewAllClick(issueType: TIssueType) {
    const selectedOperationDepartment = this.operationAndSelectedIssueList[this.activeIndex].operation.department;
    if (selectedOperationDepartment) {
      const modal = await this.modalCtrl.create({
        component: FilterMasterdataListComponent,
        componentProps: {
          type: 'OPERATION_OR_DEFECT',
          lists: issueType === 'GENERIC_ISSUE' ? this.filteredAllGenericIssue : this.filteredAllMappedIssues,
          preSelectedLists: issueType === 'GENERIC_ISSUE' ? this.filteredGenericIssue : this.filteredMappedIssues,
          title: 'issue_selection.listOfIssues',
          showCategoryId: true,
        },
        cssClass: 'm-modal_reject_flow_component',
        backdropDismiss: false,
      });
      await modal.present();
      modal.onDidDismiss().then((res) => {
        if (res.data) {
          const t = res.data as IDefectList[];
          const updatedFilterList: TUpdateFilteredListsV3 = {
            type: issueType === 'GENERIC_ISSUE' ? 'FILTERED_GENERIC_ISSUE_LIST' : 'FILTERED_MAPPED_ISSUE_LIST',
            department: selectedOperationDepartment,
            list: t.map((x) => x.name),
            ...(issueType !== 'GENERIC_ISSUE' && {
              operation_id: this.operationAndSelectedIssueList[this.activeIndex].operation.id,
            }),
          };

          this.viewAll.emit(updatedFilterList);
        }
      });
    }
  }

  updateActiveIndex(index: number) {
    this.activeIndex = index;
    this.setCurrentSelectedOperationBasedOnActiveIndex();
    this.updateFilteredIssues();
  }

  setCurrentSelectedOperationBasedOnActiveIndex() {
    const selectedOperationDept = this.operationAndSelectedIssueList[this.activeIndex].operation.department;
    if (selectedOperationDept) {
      const operationWithIssue = this.departmentWiseOperationListAndGenericIssueMap[
        selectedOperationDept
      ].operationsList.find((ele) => ele.id === this.operationAndSelectedIssueList[this.activeIndex].operation.id);
      if (operationWithIssue) {
        this.currentOperationSelected = operationWithIssue;
      }
    }
  }

  handleBack() {
    this.back.emit(this.operationAndSelectedIssueList);
  }

  handleNext() {
    const isNextCondition = !this.operationAndSelectedIssueList.find(
      (item) => item.selectedGenericIssue.length === 0 && item.selectedMappedIssue.length === 0,
    );
    if (isNextCondition) {
      console.log('[FINAL_SELECTED_OPERATION_AND_ISSUE_LIST]', this.operationAndSelectedIssueList);
      this.next.emit(this.operationAndSelectedIssueList);
    } else
      this.inputAppAPIHelperUtil.showPopup(
        this.translate.instant('input_app_common.alert'),
        this.translate.instant('issue_selection.pleaseSelectItems'),
      );
  }

  handleCancel() {
    this.cancel.emit('CANCEL');
  }

  handleClearAll() {
    this.operationAndSelectedIssueList = this.operationAndSelectedIssueList.map((item) => {
      return {
        ...item,
        selectedGenericIssue: [],
        selectedMappedIssue: [],
      };
    });
    this.clearAll.emit('CLEAR_ALL');
  }

  handleIssueSelection(selectedIssues: THandleIssueOperationSelectionList, issueType: TIssueType) {
    if (issueType === 'GENERIC_ISSUE') {
      this.operationAndSelectedIssueList[this.activeIndex].selectedGenericIssue = selectedIssues as IDefectList[];
    } else if (issueType === 'MAPPED_ISSUE') {
      this.operationAndSelectedIssueList[this.activeIndex].selectedMappedIssue = selectedIssues as IDefectList[];
    }
  }
}
